import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCircleRed = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 8,
		cy: 8,
		r: 5.5,
		fill: "#E37D98",
		stroke: "#C94769"
	})
});
export default SvgCircleRed;
